import { TFunction } from 'i18next';

export const changeRequestNotificationMessage = (
  t: TFunction,
  enableFourEyes: boolean
) =>
  enableFourEyes
    ? t('global.notifications.changeSentForApproval')
    : t('global.notifications.changeApplied');

export const changeRequestButtonMessage = (
  t: TFunction,
  enableFourEyes: boolean
) =>
  enableFourEyes
    ? t('global.buttons.submitForApproval')
    : t('enso.labels.create');